import React from 'react';

import { flagStyles } from '../settings';

const SvgMF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3336px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMF;
